'use client'

import { motion } from 'framer-motion'

export default function HeroContent() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="space-y-2 text-white sm:space-y-4">
        <span className="block text-3xl font-bold sm:text-4xl md:text-5xl lg:text-6xl">
          Wir sind
        </span>
        <span className="block text-3xl font-bold sm:text-4xl md:text-5xl lg:text-6xl">
          <span className="text-[#ff4500]">Go</span>Deutschland
        </span>
      </h1>
      <p className="mt-8 sm:mt-8 md:mt-8 lg:mt-8">
        <span className="block text-lg font-semibold text-white sm:text-xl md:text-2xl">
          "Die Volk-Energielösung"
        </span>
      </p>
    </motion.div>
  )
}
